// extracted by mini-css-extract-plugin
export default {"loader":"ec3266","loader__text-light":"bb70a6","loaderTextLight":"bb70a6","loader__text-gray":"b596d0","loaderTextGray":"b596d0","loader__text-red":"f8d6d9","loaderTextRed":"f8d6d9"};